import PropTypes from 'prop-types';
import React from 'react';

const GoInactive = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="512" y="181" width="904" height="493" rx="12" fill="white" />
    <path
      d="M1312.49 584.362C1312.32 584.362 1312.28 584.283 1312.37 584.166L1313.25 583.106C1313.33 582.989 1313.54 582.91 1313.71 582.91H1328.65C1328.82 582.91 1328.86 583.028 1328.78 583.146L1328.07 584.166C1327.98 584.283 1327.77 584.401 1327.65 584.401L1312.49 584.362Z"
      fill="#00ACD7"
    />
    <path
      d="M1306.17 587.971C1306 587.971 1305.96 587.893 1306.04 587.775L1306.92 586.716C1307 586.598 1307.21 586.52 1307.38 586.52H1326.48C1326.64 586.52 1326.73 586.637 1326.68 586.755L1326.35 587.696C1326.31 587.853 1326.14 587.932 1325.97 587.932L1306.17 587.971Z"
      fill="#00ACD7"
    />
    <path
      d="M1316.3 591.581C1316.13 591.581 1316.09 591.463 1316.17 591.345L1316.76 590.364C1316.84 590.247 1317.01 590.129 1317.18 590.129H1325.55C1325.72 590.129 1325.81 590.247 1325.81 590.404L1325.72 591.345C1325.72 591.502 1325.55 591.62 1325.43 591.62L1316.3 591.581Z"
      fill="#00ACD7"
    />
    <path
      d="M1359.77 583.656C1357.13 584.283 1355.33 584.754 1352.73 585.382C1352.1 585.539 1352.06 585.578 1351.52 584.99C1350.89 584.323 1350.43 583.891 1349.55 583.499C1346.91 582.283 1344.36 582.636 1341.97 584.087C1339.12 585.814 1337.66 588.364 1337.7 591.542C1337.74 594.681 1340.04 597.27 1343.35 597.702C1346.2 598.055 1348.59 597.113 1350.47 595.112C1350.85 594.681 1351.18 594.21 1351.6 593.66H1343.52C1342.64 593.66 1342.43 593.15 1342.72 592.483C1343.27 591.267 1344.27 589.227 1344.86 588.207C1344.98 587.971 1345.28 587.579 1345.91 587.579H1361.15C1361.06 588.638 1361.06 589.698 1360.9 590.757C1360.44 593.582 1359.3 596.171 1357.46 598.447C1354.45 602.174 1350.51 604.489 1345.53 605.117C1341.43 605.627 1337.61 604.881 1334.27 602.527C1331.17 600.33 1329.41 597.427 1328.95 593.817C1328.4 589.541 1329.74 585.696 1332.51 582.322C1335.48 578.673 1339.42 576.358 1344.23 575.534C1348.17 574.867 1351.94 575.299 1355.33 577.457C1357.55 578.83 1359.14 580.713 1360.18 582.989C1360.44 583.342 1360.27 583.538 1359.77 583.656Z"
      fill="#00ACD7"
    />
    <path
      d="M1373.63 605.352C1369.82 605.274 1366.34 604.254 1363.41 601.9C1360.94 599.899 1359.39 597.348 1358.89 594.327C1358.13 589.894 1359.43 585.97 1362.28 582.479C1365.33 578.712 1369.02 576.75 1374 575.927C1378.27 575.22 1382.29 575.613 1385.94 577.927C1389.24 580.046 1391.3 582.91 1391.84 586.677C1392.55 591.973 1390.92 596.289 1387.02 599.977C1384.26 602.606 1380.87 604.254 1376.98 604.999C1375.84 605.195 1374.71 605.234 1373.63 605.352ZM1383.59 589.502C1383.55 588.992 1383.55 588.599 1383.47 588.207C1382.71 584.323 1378.9 582.126 1374.92 582.989C1371.03 583.813 1368.52 586.127 1367.6 589.815C1366.84 592.876 1368.43 595.975 1371.45 597.231C1373.75 598.172 1376.05 598.055 1378.27 596.995C1381.58 595.387 1383.38 592.876 1383.59 589.502Z"
      fill="#00ACD7"
    />
    <rect x="561" y="218" width="1" height="456" fill="#E4E6E7" />
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="528" y="249.938">
        54&#10;
      </tspan>
      <tspan x="528" y="270.938">
        55&#10;
      </tspan>
      <tspan x="528" y="291.938">
        56&#10;
      </tspan>
      <tspan x="528" y="312.938">
        57&#10;
      </tspan>
      <tspan x="528" y="333.938">
        58&#10;
      </tspan>
      <tspan x="528" y="354.938">
        58&#10;
      </tspan>
      <tspan x="528" y="375.938">
        60&#10;
      </tspan>
      <tspan x="528" y="396.938">
        61&#10;
      </tspan>
      <tspan x="528" y="417.938">
        62&#10;
      </tspan>
      <tspan x="528" y="438.938">
        63&#10;
      </tspan>
      <tspan x="528" y="459.938">
        64&#10;
      </tspan>
      <tspan x="528" y="480.938">
        65&#10;
      </tspan>
      <tspan x="528" y="501.938">
        66&#10;
      </tspan>
      <tspan x="528" y="522.938">
        67&#10;
      </tspan>
      <tspan x="528" y="543.938">
        68&#10;
      </tspan>
      <tspan x="528" y="564.938">
        69&#10;
      </tspan>
      <tspan x="528" y="585.938">
        70&#10;
      </tspan>
      <tspan x="528" y="606.938">
        71&#10;
      </tspan>
      <tspan x="528" y="627.938">
        72&#10;
      </tspan>
      <tspan x="528" y="648.938">
        73
      </tspan>
    </text>
    <path
      d="M512 193C512 186.373 517.373 181 524 181H1404C1410.63 181 1416 186.373 1416 193V217H512V193Z"
      fill="white"
    />
    <circle cx="534" cy="199" r="6" fill="#FD0054" />
    <circle cx="554" cy="199" r="6" fill="#FFB31A" />
    <circle cx="574" cy="199" r="6" fill="#00CC21" />
    <rect x="512" y="217" width="904" height="1" fill="#E4E6E7" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="619.633" y="249.938">
        {' '}
        (g{' '}
      </tspan>
      <tspan x="661.674" y="249.938">
        Graph){' '}
      </tspan>
      <tspan x="813.021" y="249.938">
        (start, end int) (isReachable bool, distance int, err error) {'{'}&#10;
      </tspan>
      <tspan x="586" y="270.938">
        {' '}
        INF{' '}
      </tspan>
      <tspan x="644.857" y="270.938">
        {' '}
        math.
      </tspan>
      <tspan x="720.531" y="270.938">
        (
      </tspan>
      <tspan x="737.348" y="270.938">
        )&#10;
      </tspan>
      <tspan x="586" y="291.938">
        {' '}
        distances{' '}
      </tspan>
      <tspan x="695.307" y="291.938">
        {' '}
      </tspan>
      <tspan x="737.348" y="291.938">
        ([]float64, g.
      </tspan>
      <tspan x="922.328" y="291.938">
        )&#10;
      </tspan>
      <tspan x="586" y="312.938" />
      <tspan x="586" y="354.938">
        {' '}
      </tspan>
      <tspan x="619.633" y="354.938">
        {' '}
        i{' '}
      </tspan>
      <tspan x="661.674" y="354.938">
        {' '}
        0; i &#60; g.
      </tspan>
      <tspan x="813.021" y="354.938">
        ; i
      </tspan>
      <tspan x="855.062" y="354.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="375.938">
        {' '}
        distances[i]{' '}
      </tspan>
      <tspan x="720.531" y="375.938">
        {' '}
        INF&#10;
      </tspan>
      <tspan x="586" y="396.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="586" y="417.938">
        {' '}
        distances[start]{' '}
      </tspan>
      <tspan x="586" y="438.938" />
      <tspan x="586" y="459.938">
        {' '}
      </tspan>
      <tspan x="586" y="480.938">
        {' '}
      </tspan>
      <tspan x="619.633" y="480.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="678.49" y="480.938">
        ; n{' '}
      </tspan>
      <tspan x="720.531" y="480.938">
        {' '}
        g.
      </tspan>
      <tspan x="813.021" y="480.938">
        ; n
      </tspan>
      <tspan x="855.062" y="480.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="501.938" />
      <tspan x="586" y="522.938">
        {' '}
      </tspan>
      <tspan x="586" y="543.938">
        {' '}
      </tspan>
      <tspan x="628.041" y="543.938">
        {' '}
        u, adjacents{' '}
      </tspan>
      <tspan x="762.572" y="543.938">
        {' '}
      </tspan>
      <tspan x="813.021" y="543.938">
        {' '}
        g.
      </tspan>
      <tspan x="880.287" y="543.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="586" y="564.938">
        {' '}
      </tspan>
      <tspan x="636.449" y="564.938">
        {' '}
        v, weightUV{' '}
      </tspan>
      <tspan x="762.572" y="564.938">
        {' '}
      </tspan>
      <tspan x="813.021" y="564.938">
        {' '}
        adjacents {'{'}&#10;
      </tspan>
      <tspan x="586" y="585.938" />
      <tspan x="586" y="606.938">
        {' '}
      </tspan>
      <tspan x="586" y="627.938">
        {' '}
      </tspan>
      <tspan x="636.449" y="627.938">
        {' '}
        newDistance{' '}
      </tspan>
      <tspan x="762.572" y="627.938">
        {' '}
        distances[u]{' '}
      </tspan>
      <tspan x="888.695" y="627.938">
        {' '}
      </tspan>
      <tspan x="955.961" y="627.938">
        (weightUV); distances[v]{' '}
      </tspan>
      <tspan x="1174.57" y="627.938">
        {' '}
        newDistance {'{'}&#10;
      </tspan>
      <tspan x="586" y="648.938">
        {' '}
        distances[v]{' '}
      </tspan>
      <tspan x="745.756" y="648.938">
        {' '}
        newDistance
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="586" y="333.938">
        {' '}
        // Set all vertices to unreachable, initialize source&#10;
      </tspan>
      <tspan x="594.408" y="459.938">
        // Making iterations equal to #vertices&#10;
      </tspan>
      <tspan x="602.816" y="522.938">
        // Looping over all edges&#10;
      </tspan>
      <tspan x="619.633" y="606.938">
        // If new shorter distance is found, update distance value (relaxation step)&#10;
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="586" y="249.938">
        func
      </tspan>
      <tspan x="594.408" y="354.938">
        for
      </tspan>
      <tspan x="594.408" y="480.938">
        for
      </tspan>
      <tspan x="602.816" y="543.938">
        for
      </tspan>
      <tspan x="770.98" y="543.938">
        range
      </tspan>
      <tspan x="611.225" y="564.938">
        for
      </tspan>
      <tspan x="770.98" y="564.938">
        range
      </tspan>
      <tspan x="619.633" y="627.938">
        if
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="653.266" y="249.938">
        *
      </tspan>
      <tspan x="628.041" y="270.938">
        :=
      </tspan>
      <tspan x="728.939" y="270.938">
        1
      </tspan>
      <tspan x="678.49" y="291.938">
        :=
      </tspan>
      <tspan x="855.062" y="291.938">
        vertices
      </tspan>
      <tspan x="644.857" y="354.938">
        :=
      </tspan>
      <tspan x="745.756" y="354.938">
        vertices
      </tspan>
      <tspan x="838.246" y="354.938">
        ++
      </tspan>
      <tspan x="712.123" y="375.938">
        =
      </tspan>
      <tspan x="737.348" y="417.938">
        = 0&#10;
      </tspan>
      <tspan x="644.857" y="480.938">
        := 0
      </tspan>
      <tspan x="712.123" y="480.938">
        &#60;
      </tspan>
      <tspan x="745.756" y="480.938">
        vertices
      </tspan>
      <tspan x="838.246" y="480.938">
        ++
      </tspan>
      <tspan x="745.756" y="543.938">
        :=
      </tspan>
      <tspan x="838.246" y="543.938">
        edges
      </tspan>
      <tspan x="745.756" y="564.938">
        :=
      </tspan>
      <tspan x="745.756" y="627.938">
        :=
      </tspan>
      <tspan x="880.287" y="627.938">
        +
      </tspan>
      <tspan x="1166.17" y="627.938">
        &#62;
      </tspan>
      <tspan x="737.348" y="648.938">
        =
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="720.531" y="249.938">
        BellmanFord
      </tspan>
      <tspan x="695.307" y="270.938">
        Inf
      </tspan>
      <tspan x="703.715" y="291.938">
        make
      </tspan>
      <tspan x="897.104" y="627.938">
        float64
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_12490)">
      <rect x="496" y="181" width="936" height="493" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="496" y="277" width="936" height="24" fill="#FD0054" />
    <path
      d="M1318.32 630.296C1318.13 630.296 1318.09 630.207 1318.18 630.074L1319.17 628.878C1319.27 628.745 1319.5 628.656 1319.69 628.656H1336.55C1336.74 628.656 1336.79 628.789 1336.69 628.922L1335.89 630.074C1335.79 630.207 1335.56 630.34 1335.42 630.34L1318.32 630.296Z"
      fill="#00ACD7"
    />
    <path
      d="M1311.19 634.374C1311 634.374 1310.95 634.285 1311.05 634.152L1312.04 632.956C1312.13 632.823 1312.37 632.734 1312.56 632.734H1334.09C1334.28 632.734 1334.38 632.867 1334.33 633L1333.95 634.064C1333.9 634.241 1333.71 634.329 1333.53 634.329L1311.19 634.374Z"
      fill="#00ACD7"
    />
    <path
      d="M1322.62 638.448C1322.43 638.448 1322.38 638.315 1322.48 638.182L1323.14 637.074C1323.23 636.942 1323.42 636.809 1323.61 636.809H1333.05C1333.24 636.809 1333.34 636.942 1333.34 637.119L1333.24 638.182C1333.24 638.359 1333.05 638.492 1332.91 638.492L1322.62 638.448Z"
      fill="#00ACD7"
    />
    <path
      d="M1371.65 629.497C1368.68 630.206 1366.65 630.738 1363.72 631.447C1363.01 631.624 1362.96 631.668 1362.35 631.004C1361.64 630.251 1361.12 629.763 1360.13 629.32C1357.16 627.946 1354.27 628.345 1351.58 629.985C1348.37 631.934 1346.72 634.814 1346.77 638.403C1346.81 641.948 1349.41 644.872 1353.14 645.36C1356.35 645.759 1359.04 644.695 1361.17 642.435C1361.59 641.948 1361.97 641.416 1362.44 640.796H1353.33C1352.34 640.796 1352.1 640.22 1352.43 639.467C1353.05 638.093 1354.18 635.789 1354.84 634.637C1354.98 634.371 1355.31 633.928 1356.02 633.928H1373.21C1373.12 635.125 1373.12 636.321 1372.93 637.517C1372.41 640.707 1371.13 643.632 1369.06 646.202C1365.66 650.411 1361.22 653.025 1355.6 653.734C1350.97 654.31 1346.67 653.468 1342.89 650.81C1339.4 648.329 1337.42 645.05 1336.9 640.973C1336.28 636.144 1337.79 631.801 1340.91 627.991C1344.26 623.87 1348.7 621.256 1354.13 620.325C1358.57 619.572 1362.82 620.06 1366.65 622.497C1369.15 624.047 1370.94 626.174 1372.13 628.744C1372.41 629.143 1372.22 629.364 1371.65 629.497Z"
      fill="#00ACD7"
    />
    <path
      d="M1387.28 654C1382.99 653.911 1379.07 652.759 1375.76 650.101C1372.97 647.841 1371.23 644.961 1370.66 641.549C1369.81 636.542 1371.27 632.111 1374.48 628.168C1377.93 623.914 1382.09 621.699 1387.71 620.768C1392.52 619.971 1397.06 620.414 1401.17 623.028C1404.9 625.421 1407.21 628.655 1407.82 632.909C1408.63 638.891 1406.79 643.765 1402.39 647.93C1399.28 650.898 1395.45 652.759 1391.06 653.601C1389.79 653.823 1388.51 653.867 1387.28 654ZM1398.52 636.099C1398.47 635.523 1398.47 635.08 1398.38 634.637C1397.53 630.25 1393.23 627.769 1388.75 628.744C1384.35 629.674 1381.52 632.289 1380.48 636.454C1379.63 639.91 1381.43 643.41 1384.83 644.828C1387.42 645.891 1390.02 645.759 1392.52 644.562C1396.25 642.746 1398.29 639.91 1398.52 636.099Z"
      fill="#00ACD7"
    />
    <rect opacity="0.1" x="545" y="218" width="1" height="456" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="512.184" y="249.938">
        54&#10;
      </tspan>
      <tspan x="512.184" y="270.938">
        55&#10;
      </tspan>
      <tspan x="512.184" y="291.938">
        56&#10;
      </tspan>
      <tspan x="512.184" y="312.938">
        57&#10;
      </tspan>
      <tspan x="512.184" y="333.938">
        58&#10;
      </tspan>
      <tspan x="512.184" y="354.938">
        58&#10;
      </tspan>
      <tspan x="512.184" y="375.938">
        60&#10;
      </tspan>
      <tspan x="512.184" y="396.938">
        61&#10;
      </tspan>
      <tspan x="512.184" y="417.938">
        62&#10;
      </tspan>
      <tspan x="512.184" y="438.938">
        63&#10;
      </tspan>
      <tspan x="512.184" y="459.938">
        64&#10;
      </tspan>
      <tspan x="512.184" y="480.938">
        65&#10;
      </tspan>
      <tspan x="512.184" y="501.938">
        66&#10;
      </tspan>
      <tspan x="512.184" y="522.938">
        67&#10;
      </tspan>
      <tspan x="512.184" y="543.938">
        68&#10;
      </tspan>
      <tspan x="512.184" y="564.938">
        69&#10;
      </tspan>
      <tspan x="512.184" y="585.938">
        70&#10;
      </tspan>
      <tspan x="512.184" y="606.938">
        71&#10;
      </tspan>
      <tspan x="512.184" y="627.938">
        72&#10;
      </tspan>
      <tspan x="512.184" y="648.938">
        73
      </tspan>
    </text>
    <path
      d="M496 193C496 186.373 501.373 181 508 181H1420C1426.63 181 1432 186.373 1432 193V217H496V193Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="953.131" y="203.9">
        GO
      </tspan>
    </text>
    <circle cx="518" cy="199" r="6" fill="#FD0054" />
    <circle cx="538" cy="199" r="6" fill="#FFB31A" />
    <circle cx="558" cy="199" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="496" y="217" width="936" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="603.633" y="249.938">
        {' '}
        (g{' '}
      </tspan>
      <tspan x="645.674" y="249.938">
        Graph){' '}
      </tspan>
      <tspan x="797.021" y="249.938">
        (start, end int) (isReachable bool, distance int, err error) {'{'}&#10;
      </tspan>
      <tspan x="570" y="270.938">
        {' '}
        INF{' '}
      </tspan>
      <tspan x="628.857" y="270.938">
        {' '}
        math.
      </tspan>
      <tspan x="704.531" y="270.938">
        (
      </tspan>
      <tspan x="721.348" y="270.938">
        )&#10;
      </tspan>
      <tspan x="570" y="291.938">
        {' '}
        distances{' '}
      </tspan>
      <tspan x="679.307" y="291.938">
        {' '}
      </tspan>
      <tspan x="721.348" y="291.938">
        ([]float64, g.
      </tspan>
      <tspan x="906.328" y="291.938">
        )&#10;
      </tspan>
      <tspan x="570" y="312.938" />
      <tspan x="570" y="354.938">
        {' '}
      </tspan>
      <tspan x="603.633" y="354.938">
        {' '}
        i{' '}
      </tspan>
      <tspan x="645.674" y="354.938">
        {' '}
        0; i &#60; g.
      </tspan>
      <tspan x="797.021" y="354.938">
        ; i
      </tspan>
      <tspan x="839.062" y="354.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="375.938">
        {' '}
        distances[i]{' '}
      </tspan>
      <tspan x="704.531" y="375.938">
        {' '}
        INF&#10;
      </tspan>
      <tspan x="570" y="396.938">
        {' '}
        {'}'}&#10;
      </tspan>
      <tspan x="570" y="417.938">
        {' '}
        distances[start]{' '}
      </tspan>
      <tspan x="570" y="438.938" />
      <tspan x="570" y="459.938">
        {' '}
      </tspan>
      <tspan x="570" y="480.938">
        {' '}
      </tspan>
      <tspan x="603.633" y="480.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="662.49" y="480.938">
        ; n{' '}
      </tspan>
      <tspan x="704.531" y="480.938">
        {' '}
        g.
      </tspan>
      <tspan x="797.021" y="480.938">
        ; n
      </tspan>
      <tspan x="839.062" y="480.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="501.938" />
      <tspan x="570" y="522.938">
        {' '}
      </tspan>
      <tspan x="570" y="543.938">
        {' '}
      </tspan>
      <tspan x="612.041" y="543.938">
        {' '}
        u, adjacents{' '}
      </tspan>
      <tspan x="746.572" y="543.938">
        {' '}
      </tspan>
      <tspan x="797.021" y="543.938">
        {' '}
        g.
      </tspan>
      <tspan x="864.287" y="543.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="570" y="564.938">
        {' '}
      </tspan>
      <tspan x="620.449" y="564.938">
        {' '}
        v, weightUV{' '}
      </tspan>
      <tspan x="746.572" y="564.938">
        {' '}
      </tspan>
      <tspan x="797.021" y="564.938">
        {' '}
        adjacents {'{'}&#10;
      </tspan>
      <tspan x="570" y="585.938" />
      <tspan x="570" y="606.938">
        {' '}
      </tspan>
      <tspan x="570" y="627.938">
        {' '}
      </tspan>
      <tspan x="620.449" y="627.938">
        {' '}
        newDistance{' '}
      </tspan>
      <tspan x="746.572" y="627.938">
        {' '}
        distances[u]{' '}
      </tspan>
      <tspan x="872.695" y="627.938">
        {' '}
      </tspan>
      <tspan x="939.961" y="627.938">
        (weightUV); distances[v]{' '}
      </tspan>
      <tspan x="1158.57" y="627.938">
        {' '}
        newDistance {'{'}&#10;
      </tspan>
      <tspan x="570" y="648.938">
        {' '}
        distances[v]{' '}
      </tspan>
      <tspan x="729.756" y="648.938">
        {' '}
        newDistance
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="570" y="333.938">
        {' '}
        // Set all vertices to unreachable, initialize source&#10;
      </tspan>
      <tspan x="578.408" y="459.938">
        // Making iterations equal to #vertices&#10;
      </tspan>
      <tspan x="586.816" y="522.938">
        // Looping over all edges&#10;
      </tspan>
      <tspan x="603.633" y="606.938">
        // If new shorter distance is found, update distance value (relaxation step)&#10;
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="570" y="249.938">
        func
      </tspan>
      <tspan x="578.408" y="354.938">
        for
      </tspan>
      <tspan x="578.408" y="480.938">
        for
      </tspan>
      <tspan x="586.816" y="543.938">
        for
      </tspan>
      <tspan x="754.98" y="543.938">
        range
      </tspan>
      <tspan x="595.225" y="564.938">
        for
      </tspan>
      <tspan x="754.98" y="564.938">
        range
      </tspan>
      <tspan x="603.633" y="627.938">
        if
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="637.266" y="249.938">
        *
      </tspan>
      <tspan x="612.041" y="270.938">
        :=
      </tspan>
      <tspan x="712.939" y="270.938">
        1
      </tspan>
      <tspan x="662.49" y="291.938">
        :=
      </tspan>
      <tspan x="839.062" y="291.938">
        vertices
      </tspan>
      <tspan x="628.857" y="354.938">
        :=
      </tspan>
      <tspan x="729.756" y="354.938">
        vertices
      </tspan>
      <tspan x="822.246" y="354.938">
        ++
      </tspan>
      <tspan x="696.123" y="375.938">
        =
      </tspan>
      <tspan x="721.348" y="417.938">
        = 0&#10;
      </tspan>
      <tspan x="628.857" y="480.938">
        := 0
      </tspan>
      <tspan x="696.123" y="480.938">
        &#60;
      </tspan>
      <tspan x="729.756" y="480.938">
        vertices
      </tspan>
      <tspan x="822.246" y="480.938">
        ++
      </tspan>
      <tspan x="729.756" y="543.938">
        :=
      </tspan>
      <tspan x="822.246" y="543.938">
        edges
      </tspan>
      <tspan x="729.756" y="564.938">
        :=
      </tspan>
      <tspan x="729.756" y="627.938">
        :=
      </tspan>
      <tspan x="864.287" y="627.938">
        +
      </tspan>
      <tspan x="1150.17" y="627.938">
        &#62;
      </tspan>
      <tspan x="721.348" y="648.938">
        =
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="704.531" y="249.938">
        BellmanFord
      </tspan>
      <tspan x="679.307" y="270.938">
        Inf
      </tspan>
      <tspan x="687.715" y="291.938">
        make
      </tspan>
      <tspan x="881.104" y="627.938">
        float64
      </tspan>
    </text>
    <path
      d="M1440 299H1523V274"
      stroke="#AFB5B6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="0.01 10"
    />
    <circle cx="1523" cy="194" r="72" fill="url(#paint0_linear_1112_12490)" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="1508.09" y="155.9">
        CPU
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="44"
      fontWeight="300"
      letterSpacing="0em"
    >
      <tspan x="1479.08" y="201.4">
        88%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="13"
      letterSpacing="0em"
    >
      <tspan x="1494.7" y="224.55">
        Address:&#10;
      </tspan>
      <tspan x="1491.12" y="240.55">
        0x4553e0
      </tspan>
    </text>
    <defs>
      <filter
        id="filter0_ddd_1112_12490"
        x="456"
        y="161"
        width="1016"
        height="573"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_12490" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_12490"
          result="effect2_dropShadow_1112_12490"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_12490"
          result="effect3_dropShadow_1112_12490"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_12490"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_12490"
        x1="1595"
        y1="122"
        x2="1451"
        y2="266"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFDFD" />
        <stop offset="1" stopColor="#F4F5F6" />
      </linearGradient>
    </defs>
  </svg>
);

GoInactive.propTypes = {
  className: PropTypes.string,
};

GoInactive.defaultProps = {
  className: null,
};

export default GoInactive;
